module.exports = __webpack_public_path__ + "img/pigment_2.bd622ad6.png";